module.exports = __webpack_public_path__ + "img/keyboard.fbf64c21.svg";